export const firebaseConfig = {
    apiKey: "AIzaSyD0XOLLkZiM7UTBrzonGTuQ49q08ZN9BGk",
    authDomain: "blinker2024.firebaseapp.com",
    projectId: "blinker2024",
    storageBucket: "blinker2024.appspot.com",
    messagingSenderId: "320473212810",
    appId: "1:320473212810:web:aba8274a8266e3c4358a73",
    vapidKey: "BIAWqDaeyhcn-E_kn_1oUCv88Pyr0_6skrEhwFKbm8QugeWIoiQ3gQwyINzVIdglDpwvtmWrq4ynOcQXJ3bSn5Y"
};
